<template>
    <div class="container">
      <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="item in list" :key="item" :title="item" />
      </van-list> -->
      <div v-for="item in $store.getters.reocrdList">
      <div class="content-info" @click="checkInfo(item)">
        <div class="content-head">
          <img :src="item.browsedMemberInfo && item.browsedMemberInfo.avatarLink || defaultPhoto" style="width: 100%;height: 100%;object-fit: cover;object-position: center;"/>
        </div>
        <div class="content-detail">
          <span class="detail-line1">{{ item.browsedMemberInfo ? item.browsedMemberInfo.nickName || formatSerial(item.browsedMemberInfo.serialNumber) :''}}</span>
          <span class="browser-time">浏览时间:{{getCompleteTime(item.browseTime)}}</span>
          <div class="detail-line2">
            <span>
              <span>性别:</span>
              <span>{{item.browsedMemberInfo && item.browsedMemberInfo.sex === 1 ? '男' : '女'}}</span>
            </span>
            <span>
              <span>年纪:</span>
              <span>{{item.browsedMemberInfo && getUpdateTime(item.browsedMemberInfo.birthday)}}</span>
            </span>
            <span>
              <span>身高:</span>
              <span>{{item.browsedMemberInfo && item.browsedMemberInfo.height}}CM</span>
            </span>
          </div>
          <div class="detail-line3">
            <span>
              <span>籍贯:</span>
              <span>{{item.browsedMemberInfo && item.browsedMemberInfo.hometown}}</span>
            </span>
            <!-- <span style="margin-left: 1rem" v-if="item.browsedMemberInfo && item.browsedMemberInfo.hometown.length < 10">
              <span>学历:</span>
              <span>{{item.browsedMemberInfo && educationData[item.browsedMemberInfo.education - 1]}}</span>
            </span> -->
          </div>
          <!-- <div class="detail-line4" v-if="item.browsedMemberInfo && item.browsedMemberInfo.hometown.length > 10">
            <span>
              <span>学历:</span>
              <span>{{item.browsedMemberInfo && educationData[item.browsedMemberInfo.education - 1]}}</span>
            </span>
          </div> -->
        </div>
        <div class="content-go"></div>
      </div>
      </div>
    </div>
      
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MemberCheck',
  // props: {
  //   infoList: Array,
  // },
  data() {
    return {
      showPicker: false,
      value: '',
      columns : ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华'],
      list: [],
      loading: false,
      finished: false,
      queryVisible: true,
      educationData: [
        '大专', '本科', '硕士', '博士', '高中及以下'
      ],
    };
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = true;
    },
    click() {
      this.queryVisible = false;
    },
    checkInfo(item) {
      // 跳转下个页面记录当前节点， 其实这里不用也没关系
      this.$store.dispatch('SetQueryName', 'check');
      this.$router.push({path: `/detailInformation/${item.browsedMemberInfo.id}`,});
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    getUpdateTime(time) {
      let birthYear = Number(time.slice(0, 4));
      let Y = new Date().getFullYear();
      return Y - birthYear;
    },
    formatSerial(serialNumber) {
      if (!serialNumber) return "0000";
      return String(serialNumber).padStart(4, "0");
    },
  },
  created() {
  },
   computed: {
    ...mapGetters([
      'baseInfo'
    ]),
   }
};
</script>
<style scoped lang="less">
@import url('../../style/theme-variables.less');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  padding: 0.95rem 0.8rem 0;
}

.content-info {
  width: 100%;
  min-height: 5.2rem;
  margin-bottom: 0.8rem;
  padding: 0.85rem 0.9rem;
  background: @bg-card;
  border-radius: @radius-large;
  box-shadow: @shadow-card;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .content-head {
    width: 3.35rem;
    height: 3.35rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: @shadow-avatar;
  }

  .content-detail {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.28rem;

    .detail-line1 {
      font-size: 0.72rem;
      font-weight: @font-weight-semibold;
      color: @text-primary;
      line-height: 1rem;
    }

    .browser-time {
      font-size: 0.54rem;
      color: @text-tertiary;
      line-height: 0.8rem;
    }

    .detail-line2,
    .detail-line3 {
      font-size: 0.58rem;
      color: @text-secondary;
      line-height: 0.86rem;
      display: flex;
      justify-content: space-between;
      gap: 0.4rem;
    }

    .detail-line3 {
      justify-content: flex-start;
    }
  }

  .content-go {
    width: 0.7rem;
    height: 0.7rem;
    flex-shrink: 0;
    background: url("../../assets/btn_arrow_black_6x6.png") no-repeat center;
    background-size: 0.42rem 0.42rem;
    opacity: 0.55;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matchmakerCenter/memberCheck.vue